<script>
import CheckBox from '..//components/Form/CheckBox.vue';

export default {
  components: { CheckBox },
  props: {
    checkedRules: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:checkedRules'],
  methods: {
    handleCheckingRulesUpdate(value, checked) {
      this.$emit('update:checkedRules', checked);
    },
  },
};
</script>

<template>
  <div class="flex flex-row items-start gap-2">
    <CheckBox
      value="MyCheckBox"
      :is-checked="checkedRules"
      @update="handleCheckingRulesUpdate"
    />
    <span class="text-3 text-rulesText text-xs min-[1440px]:text-sm dark:text-slate-400">
      {{ $t('GENERAL.RULES.PART1') }}
      <a href="https://gapify.ai/terms-conditions/" class="text-gapify">
        {{ $t('GENERAL.RULES.GAPIFY_RULES') }}
      </a>
      {{ $t('GENERAL.RULES.PART2') }}
      <a href="https://gapify.ai/privacy-policy/" class="text-gapify">
        {{ $t('GENERAL.RULES.PRIVACY') }}
      </a>
      {{ $t('GENERAL.RULES.PART3') }}
    </span>
    <!--                    <router-link to="auth/signup" class="lowercase text-link">-->
    <!--                      {{ $t('LOGIN.CREATE_NEW_ACCOUNT') }}-->
    <!--                    </router-link>-->
  </div>
</template>

<style scoped lang="scss"></style>
